import { ChevronDownIcon } from "./Icons";

export function MobilePanelToggle({
  label,
  status,
  expanded,
  controls,
  onToggle,
  disabled = false,
}: {
  label: string;
  status?: string;
  expanded: boolean;
  controls: string;
  onToggle: () => void;
  disabled?: boolean;
}) {
  return (
    <button
      className="mobile-panel-toggle"
      type="button"
      aria-expanded={expanded}
      aria-controls={controls}
      onClick={onToggle}
      disabled={disabled}
    >
      <span>{label}</span>
      <span className="mobile-panel-meta">
        {status ? <small>{status}</small> : null}
        <ChevronDownIcon />
      </span>
    </button>
  );
}
